import styled, { css } from 'styled-components';

import { bodyRegular, captionRegular } from 'styles/mixins/fonts';

export const Warning = styled.p`
  ${bodyRegular};
  padding: 12px 16px;
  border-radius: 12px;
  ${({ theme }) => css`
    color: ${theme.colors.red.primary.standard};
    background: ${theme.colors.red.tertiary.standard};
  `}
`;

// A P&L line that opens a drawer: keyboard reachable, with a focus ring drawn
// inside the row (the expenses list scrolls and would clip an outer outline;
// the positioned card would cover an inset one). The look is the ListCard's.
export const LineButton = styled.div`
  border-radius: 16px;

  &:focus {
    outline: none;
  }

  &:focus-visible > div {
    box-shadow: inset 0 0 0 2px
      ${({ theme }) => theme.colors.blue.primary.standard};
  }
`;

// The drawer's content in one block, so its height can be measured.
export const DrawerContent = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

// The title block starts where the rows' text starts and the close button
// ends where the rows' last column ends (row inset 24px + 1px border; phone
// cards: 16px). The close button sits on the title's first line.
export const Header = styled.div`
  gap: 24px;
  display: flex;
  padding: 0 25px;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 767px) {
    padding: 0 16px;
  }

  > button {
    flex-shrink: 0;
    margin-top: 4px;
  }
`;

// Up to two lines each (a long category or event name on a phone), never
// under the close button.
export const HeaderText = styled.div`
  min-width: 0;

  h2,
  p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
  }

  /* Mukta draws ~4px (h2) / ~2px (caption) above and below its line box;
     the padding keeps those glyph edges inside the clamped box, the
     negative margin keeps the lines where they were. */
  h2 {
    padding: 4px 0;
    margin: -4px 0;
  }

  p {
    ${captionRegular};
    padding: 2px 0;
    margin: -2px 0;
    color: ${({ theme }) => theme.config.table.head.title};
  }
`;

// A P&L line whose name carries a short note under it (Tax: the refunded
// tax), in the caption style of the drawer subtitles.
export const NamedLine = styled.span`
  display: flex;
  flex-direction: column;
`;

export const LineNote = styled.span`
  ${captionRegular};
  color: ${({ theme }) => theme.config.table.head.title};
`;
